import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { FollowUpGET } from '../../../models/followUpGET';
import { MetaData } from '../../../models/metaData';

import { ConfigService } from '../../config.service';
import { DataStorageService } from '../../data-storage.service';
import { SecurityService } from '../../security.service';

interface PostFollowUpResponse {
  id: number;
  date: string;
  salesStage: string;
  nextStep: string;
  nextDate: string;
}

@Injectable()
export class ApiFollowUpService {

  constructor(public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    public configService: ConfigService,
    public http: HttpClient) {
  }

  getFollowUp(offerID: number) {
    const url = this.configService.host + '/api/offer/' + offerID + '/followup';
    this.http.get<FollowUpGET>(url)
      .toPromise()
      .then(res => {
        this.dataStorageService.currentState.offerID = offerID;
        this.dataStorageService.currentState.followupNotify = res.followupNotify;
        this.dataStorageService.currentState.descriprionOfTheProject = res['description'];
        this.dataStorageService.currentState.solutionOfTheProject = res['solution'],
        this.dataStorageService.currentState.metaData = res['followups'];
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken().then(() => this.getFollowUp(offerID));
        } else {
          alert(error.message);
        }
      });
  }

  postFollowUp(body: { date: string, salesStage: string, nextStep: string, nextDate: string }): Promise<MetaData> {
    const url = this.configService.host
      + '/api'
      + '/offer/'
      + this.dataStorageService.currentState.offerID
      + '/followup';
    if (this.dataStorageService.currentState.status === 'OPEN' || this.canReopenOffer()) {
      return new Promise<MetaData>((resolve, reject) => {
        const dummy = new MetaData();
        this.http.post<PostFollowUpResponse>(url, body)
          .toPromise()
          .then((response) => {
            dummy.id = response.id;
            dummy.salesStage = response.salesStage;
            dummy.nextDate = response.nextDate;
            dummy.nextStep = response.nextStep;
            dummy.date = response.date;
            resolve(dummy);
          }).catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken().then(() => {
                this.postFollowUp(body).then(data => resolve(data));
              });
            } else {
              if (error.status === 403) {
                alert('You can not modify LOST/WON offer !');
              }
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }


  putFollowUp(offerID?, body?): Promise<any> {

    offerID = offerID ? offerID : this.dataStorageService.currentState.offerID;
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/followup';
    body = body ? body : {
      'description': this.dataStorageService.currentState.descriprionOfTheProject,
      'solution': this.dataStorageService.currentState.solutionOfTheProject,
      'followupNotify': this.dataStorageService.currentState.followupNotify,
      'followups': this.dataStorageService.currentState.metaData
    };

    if (this.dataStorageService.currentState.status === 'OPEN' || this.canReopenOffer()) {
      return new Promise<any>((resolve, reject) => {

        this.http.put(url, body)
          .toPromise()
          .then(() => {
            resolve();
          }).catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putFollowUp().then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteFollowUp(followUpID: number): Promise<any> {
    return new Promise<any>(((resolve, reject) => {
      const url = this.configService.host
        + '/api/offer/'
        + this.dataStorageService.currentState.offerID
        + '/followup/'
        + followUpID;
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deleteFollowUp(followUpID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    }));
  }

  getSalesStage(): Promise<string[]> { // mock
    const salesStages = [
      'NEW',
      'CLOSED_WON',
      'CLOSED_LOST',
      'VISITED',
      'OFFER_SENT',
      'PROJECT_DELAYED',
      'CONTACTED',
      'REOPENED'];
    return new Promise<string[]>((resolve, reject) => {
      resolve(salesStages);
    });
  }

  getNextStep(): Promise<string[]> { // mock
    const nextStep = [
      'CONTACT',
      'SEND_OFFER',
      'WAITING_FEEDBACK',
      'FOLLOW_UP',
      'PRODUCT_PRESENTATION',
      'VISIT'];
    return new Promise<string[]>((resolve, reject) => {
      resolve(nextStep);
    });
  }

  canReopenOffer() {
    return this.securityService.isAdmin() || this.securityService.isLeader();
  }
}



// WEBPACK FOOTER //
// ./src/app/apiServices/followUp/api-follow-up.service.ts